import { LazyLoad } from '@petconsole/pure-fe-mui';

const MemberAdmin = LazyLoad(() => import('./MemberAdmin'));

export { MemberAdmin };
